import { render, staticRenderFns } from "./ZhanhuiJbzqStatBlock.vue?vue&type=template&id=003d5cdc&scoped=true"
import script from "./ZhanhuiJbzqStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiJbzqStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiJbzqStatBlock.vue?vue&type=style&index=0&id=003d5cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d5cdc",
  null
  
)

export default component.exports